@import '../../../global/reset';

:host {
	display: flow-root;
}

:host(:not([open])) {
	slot:is(
		[name='close-label'],
		[name='close-icon']
	) {
		display: none;
	}
}
:host([open]) {
	slot:is(
		[name='open-label'],
		[name='open-icon']
	) {
		display: none;
	}
}

#summary {
	display: flex;
	align-items: center;
	gap: 1em;
}

:host([interest-toggle].hide-toggle) {
	@media (hover: hover) {
		#toggle:not(:focus-visible) {
			@include visually-hidden;
		}
	}
}
